import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceMeasurement } from '../../../../model/device-measurement';
import { AssetMeasurement } from '../../../../model/asset-measurement';
import { Kpi } from '../../../../model/kpi';
import { ActionButton } from '../../../../model/ui/action-button';
import { FormGroup } from '@angular/forms';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-kpis-form-measurements',
  templateUrl: './kpis-form-measurements.component.html',
  styleUrls: ['./kpis-form-measurements.component.scss']
})
export class KpisFormMeasurementsComponent {

  @Input() kpiInfoForm: FormGroup;
  @Input() deviceMeasurements: DeviceMeasurement[];
  @Input() assetMeasurements: AssetMeasurement[];
  @Input() kpis: Kpi[];

  @Output() deviceMeasurementsChange: EventEmitter<DeviceMeasurement[]>;
  @Output() assetMeasurementsChange: EventEmitter<AssetMeasurement[]>;
  @Output() kpisChange: EventEmitter<Kpi[]>;

  public deviceMeasurementsFirst: number;
  public deviceMeasurementsRows: number;
  public displayDeviceMeasurementSelector: boolean;

  public assetMeasurementsFirst: number;
  public assetMeasurementsRows: number;
  public displayAssetMeasurementSelector: boolean;

  public measurementTabs: MenuItem[];
  public measurementTabsActive: MenuItem;

  public kpisFirst: number;
  public kpisRows: number;
  public displayKpisSelector: boolean;
  public selectKpisActions: ActionButton[];

  public infoCollapsed: boolean;
  public demoMeasurementTabs: MenuItem[];
  public demoMeasurementTabsActive: MenuItem;
  public demoDeviceMeasurements: any[];

  constructor() {
    this.deviceMeasurementsChange =  new EventEmitter<DeviceMeasurement[]>();
    this.assetMeasurementsChange =  new EventEmitter<AssetMeasurement[]>();
    this.kpisChange =  new EventEmitter<Kpi[]>();
    this.deviceMeasurementsFirst = 0;
    this.deviceMeasurementsRows = 5;
    this.assetMeasurementsFirst = 0;
    this.assetMeasurementsRows = 5;
    this.kpisFirst = 0;
    this.kpisRows = 5;
    this.displayDeviceMeasurementSelector = false;
    this.displayAssetMeasurementSelector = false;
    this.displayKpisSelector = false;
    this.selectKpisActions = [
      { label: 'select.kpis', icon: 'pi pi-check', action: (kpis: Kpi[]) => this.selectKpis(kpis) }
    ];
    this.measurementTabs = [
      { id: 'deviceMeasurements', label: 'model.deviceMeasurements', icon: 'pi pi-fw pi-mobile' },
      { id: 'assetMeasurements', label: 'model.assetMeasurements', icon: 'pi pi-fw pi-map-marker' },
      { id: 'kpis', label: 'model.kpis', icon: 'pi pi-fw pi-chart-line' }
    ];
    this.measurementTabsActive = this.measurementTabs[0];
    this.infoCollapsed = true;
    this.demoMeasurementTabs = [
      { id: 'deviceMeasurements', label: 'model.deviceMeasurements', icon: 'pi pi-fw pi-mobile' },
      { id: 'assetMeasurements', label: 'model.assetMeasurements', icon: 'pi pi-fw pi-map-marker' },
      { id: 'kpis', label: 'model.kpis', icon: 'pi pi-fw pi-chart-line' }
    ];
    this.demoMeasurementTabsActive = this.demoMeasurementTabs[0];
    this.demoDeviceMeasurements = [
      { device: { serialNumber: 'D24F350M' }, name: 'TEMPERATURE', description: 'Temperature sensor', measurementType: { sensor: 'temperature' } },
      { device: { serialNumber: 'D24F350M' }, name: 'WIND', description: 'Wind sensor', measurementType: { sensor: 'wind' } },
      { device: { serialNumber: 'D24F351M' }, name: 'TEMPERATURE', description: 'Temperature sensor', measurementType: { sensor: 'temperature' } }
    ];
  }

  private selectKpis(kpis: Kpi[]): void {
    this.displayKpisSelector = false;
    this.kpis = kpis;
    this.kpisChange.emit(this.kpis);
  }

  public removeDeviceMeasurement(measurement: DeviceMeasurement): void {
    this.deviceMeasurements.splice(this.deviceMeasurements.indexOf(measurement), 1);
    this.deviceMeasurements = [...this.deviceMeasurements];
    this.deviceMeasurementsChange.emit(this.deviceMeasurements);
  }

  public removeAssetMeasurement(measurement: AssetMeasurement): void {
    this.assetMeasurements.splice(this.assetMeasurements.indexOf(measurement), 1);
    this.assetMeasurements = [...this.assetMeasurements];
    this.assetMeasurementsChange.emit(this.assetMeasurements);
  }

  public removeKpi(kpi: Kpi): void {
    this.kpis.splice(this.kpis.indexOf(kpi), 1);
    this.kpis = [...this.kpis];
    this.kpisChange.emit(this.kpis);
  }

}
